import React from "react";
import { STATUS_BADGE, statusLabel, useLang } from "../lib/i18n";

export const StatusBadge = ({ status, className = "" }) => {
  const { lang } = useLang();
  const cls = STATUS_BADGE[status] || "bg-slate-100 text-slate-700 border-slate-200";
  const pulse = status === "in_lavorazione" ? "animate-pulse" : "";
  return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${cls} ${pulse} ${className}`}>
      {statusLabel(status, lang)}
    </span>
  );
};
